<template>
  <div class="ra-bna__thumbnails-wrapper">
    <div class="ra-bna__thumbnails" role="tablist" :aria-label="thumbnailsWrapperLabel">
      <button
        v-if="hasScrollableThumbnails"
        class="ra-bna__thumbnails-btn ra-bna__thumbnails-btn-prev"
        type="button"
        :aria-label="thumbnailNavLabelPrev"
        @click="scrollLeft"
      >
        <ba-thumbnail-arrow />
      </button>
      <ul ref="thumbnailsList" class="ra-bna__thumbnails-list" role="presentation">
        <li
          v-for="(image, index) in slides"
          :key="index"
          role="presentation"
          :class="['ra-bna__thumbnails-item', { active: activeIndex === index }]"
        >
          <button
            type="button"
            role="tab"
            class="ra-bna__thumbnails-item-icon"
            :aria-label="`${thumbnailsAccessibleLabel.replace('{{value}}', index + 1)} ${slides.length}`"
            :aria-selected="activeIndex === index ? 'true' : 'false'"
            :aria-controls="`${taggingId}-comparison-${index}`"
            :data-refapp-tagging-target="`thumbnail-${index}`"
            @click="select(index)"
          >
            <img
              :src="image.thumbnail"
              :alt="image.beforeImage.altText"
              class="ra-bna__thumbnails-image"
            />
          </button>
        </li>
      </ul>
      <button
        v-if="hasScrollableThumbnails"
        class="ra-bna__thumbnails-btn ra-bna__thumbnails-btn-next"
        type="button"
        :aria-label="thumbnailNavLabelNext"
        @click="scrollRight"
      >
        <ba-thumbnail-arrow />
      </button>
    </div>
  </div>
</template>

<script>
import BaThumbnailArrow from '../icons/thumbnail-arrow.vue';

export default {
  name: 'refapp-beforeafter-thumbnails',
  components: { BaThumbnailArrow },
  inject: [
    'taggingId',
    'slides',
    'thumbnailNavLabelNext',
    'thumbnailNavLabelPrev',
    'thumbnailsWrapperLabel',
    'thumbnailsAccessibleLabel',
  ],
  props: {
    activeIndex: { type: Number, required: true },
  },
  computed: {
    hasScrollableThumbnails() {
      return this.slides.length > 3;
    },
  },
  mounted() {
    this.setAttributesForHiddenThumbnails();
    this.$refs.thumbnailsList?.addEventListener('scroll', () => {
      setTimeout(() => {
        this.setAttributesForHiddenThumbnails();
      }, 350);
    });
  },
  methods: {
    select(index) {
      this.$emit('updateActiveLayout', index);
      if (this.$refs.thumbnailsList) {
        this.$refs.thumbnailsList.scrollLeft = index * 100 - 50;
      }
    },
    scrollLeft() {
      this.$refs.thumbnailsList?.scrollBy({ left: -100, behavior: 'smooth' });
    },
    scrollRight() {
      this.$refs.thumbnailsList?.scrollBy({ left: 100, behavior: 'smooth' });
    },
    setAttributesForHiddenThumbnails() {
      if (!this.hasScrollableThumbnails) return false;
      const list = this.$refs.thumbnailsList;
      if (!list) return false;
      const listRect = list.getBoundingClientRect();
      const thumbnails = list.querySelectorAll('.ra-bna__thumbnails-item');

      thumbnails.forEach((item) => {
        const itemRect = item.getBoundingClientRect();
        const inView = itemRect.right > listRect.left && itemRect.left < listRect.right + 10;
        const button = item.querySelector('button');
        if (button) {
          const selectedMethod = inView ? 'removeAttribute' : 'setAttribute';
          button[selectedMethod]('tabindex', -1);
          button[selectedMethod]('aria-hidden', 'true');
        }
      });
    },
  },
};
</script>
